import { render, staticRenderFns } from "./order.vue?vue&type=template&id=13caae20&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=13caae20&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13caae20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13caae20')) {
      api.createRecord('13caae20', component.options)
    } else {
      api.reload('13caae20', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=13caae20&scoped=true", function () {
      api.rerender('13caae20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sale/order.vue"
export default component.exports